// 最大4位小数的数字
const maxFourNum = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("Cannot be empty"));
  }
  setTimeout(() => {
    var reg = new RegExp(
      /^0$|^[1-9]\d{0,15}$|^[1-9]\d{0,15}\.{1}\d{1,4}$|^0\.{1}\d{1,4}$/g
    );
    if (!reg.test(value)) {
      callback(new Error("Must be a number and minimum 0.0001"));
    } else {
      if (value < 0 || value == 0) {
        callback(new Error("The minimum 0.0001"));
        return;
      }
      callback();
    }
  }, 0);
};
const isInt = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("Cannot be empty"));
  }
  setTimeout(() => {
    var reg = new RegExp(/(^[1-9]\d*$)/);
    if (!reg.test(value)) {
      callback(new Error("Must be a positive integer"));
    } else {
      callback();
    }
  }, 0);
};

export default { maxFourNum, isInt };
